// import REGION_DATA from '../../RegionData.json'
import {parse} from 'json-in-order';

import { cloneDeep } from 'lodash-es'
const json = localStorage.getItem('Region') ? localStorage.getItem('Region') : "{}";
const REGION_DATA = parse(json);
// code转汉字大对象
const CodeToText = {}
// 汉字转code大对象
const TextToCode = {}
const provinceObject = REGION_DATA.get('86') // 省份对象



const regionData = []
let provinceAndCityData = []

CodeToText[''] = '全部'

// 计算省
provinceObject.forEach((val,key) => {
  regionData.push({
    value: key, // 省份code值
    label: val // 省份汉字
  });

  CodeToText[key] = val
  TextToCode[val] = {
    code: key
  }
  TextToCode[val]['全部'] = {
    code: ''
  }
});

// 计算市
for (let i = 0, len = regionData.length; i < len; i++) {
  const provinceCode = regionData[i].value
  const provinceText = regionData[i].label
  const provinceChildren = []
  const proData = REGION_DATA.get(provinceCode);
  if(proData){
    proData.forEach((val,key) => {
      provinceChildren.push({
        value: key,
        label: val
      });
      CodeToText[key] = val;
      TextToCode[provinceText][val] = {
        code: key
      }
      TextToCode[provinceText][val]['全部'] = {
        code: ''
      }
    });
    if (provinceChildren.length) {
      regionData[i].children = provinceChildren
    }
  }
}

provinceAndCityData = cloneDeep(regionData)

// 计算区
for (let i = 0, len = regionData.length; i < len; i++) {
  const province = regionData[i].children
  const provinceText = regionData[i].label
  if (province) {
    for (let j = 0, len = province.length; j < len; j++) {
      const cityCode = province[j].value
      const cityText = province[j].label
      const cityChildren = []
      const cityData = REGION_DATA.get(cityCode);
      if(cityData){
        cityData.forEach((val,key) => {
          cityChildren.push({
            value: key,
            label: val
          });
          CodeToText[key] = val;
          TextToCode[provinceText][cityText][val] = {
            code: key
          };
        });
        if (cityChildren.length) {
          province[j].children = cityChildren
        }
      }
    }
  }
}

// 添加“全部”选项
const provinceAndCityDataPlus = cloneDeep(provinceAndCityData)
provinceAndCityDataPlus.unshift({
  value: '',
  label: '全部'
})
for (let i = 0, len = provinceAndCityDataPlus.length; i < len; i++) {
  const province = provinceAndCityDataPlus[i].children
  if (province && province.length) {
    province.unshift({
      value: '',
      label: '全部'
    })

    for (let j = 0, len = province.length; j < len; j++) {
      const city = province[j].children
      if (city && city.length) {
        city.unshift({
          value: '',
          label: '全部'
        })
      }
    }
  }
}

const regionDataPlus = cloneDeep(regionData)
regionDataPlus.unshift({
  value: '',
  label: '全部'
})
for (let i = 0, len = regionDataPlus.length; i < len; i++) {
  const province = regionDataPlus[i].children
  if (province && province.length) {
    province.unshift({
      value: '',
      label: '全部'
    })

    for (let j = 0, len = province.length; j < len; j++) {
      const city = province[j].children
      if (city && city.length) {
        city.unshift({
          value: '',
          label: '全部'
        })
      }
    }
  }
}


export { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode }
